import createIcon from '../../createIcon';

/**
 * @component @name FireHydrantAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTFIMThWOEgyMFY2SDE3LjY1QzE2LjgzIDMuNjcgMTQuNjEgMiAxMiAyQzkuMzkgMiA3LjE3IDMuNjcgNi4zNSA2SDRWOEg2VjExSDVDMy45IDExIDMgMTEuOSAzIDEzVjE1QzMgMTYuMSAzLjkgMTcgNSAxN0g2VjIwSDRWMjJIMjBWMjBIMThWMTdIMTlDMjAuMSAxNyAyMSAxNi4xIDIxIDE1VjEzQzIxIDExLjkgMjAuMSAxMSAxOSAxMVpNMTIgMTcuNUMxMC4wNyAxNy41IDguNSAxNS45MyA4LjUgMTRDOC41IDEyLjA3IDEwLjA3IDEwLjUgMTIgMTAuNUMxMy45MyAxMC41IDE1LjUgMTIuMDcgMTUuNSAxNEMxNS41IDE1LjkzIDEzLjkzIDE3LjUgMTIgMTcuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMiAxNS41QzEyLjgyODQgMTUuNSAxMy41IDE0LjgyODQgMTMuNSAxNEMxMy41IDEzLjE3MTYgMTIuODI4NCAxMi41IDEyIDEyLjVDMTEuMTcxNiAxMi41IDEwLjUgMTMuMTcxNiAxMC41IDE0QzEwLjUgMTQuODI4NCAxMS4xNzE2IDE1LjUgMTIgMTUuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FireHydrantAlt = createIcon('FireHydrantAlt', [
  [
    'path',
    {
      d: 'M19 11H18V8H20V6H17.65C16.83 3.67 14.61 2 12 2C9.39 2 7.17 3.67 6.35 6H4V8H6V11H5C3.9 11 3 11.9 3 13V15C3 16.1 3.9 17 5 17H6V20H4V22H20V20H18V17H19C20.1 17 21 16.1 21 15V13C21 11.9 20.1 11 19 11ZM12 17.5C10.07 17.5 8.5 15.93 8.5 14C8.5 12.07 10.07 10.5 12 10.5C13.93 10.5 15.5 12.07 15.5 14C15.5 15.93 13.93 17.5 12 17.5Z',
      key: 'xoz655',
    },
  ],
  [
    'path',
    {
      d: 'M12 15.5C12.8284 15.5 13.5 14.8284 13.5 14C13.5 13.1716 12.8284 12.5 12 12.5C11.1716 12.5 10.5 13.1716 10.5 14C10.5 14.8284 11.1716 15.5 12 15.5Z',
      key: 'cl119n',
    },
  ],
]);

export default FireHydrantAlt;
